module.exports = __webpack_public_path__ + "static/scale-model-of-rookery-building-in-chicago-illinois-047c0524b4ef67adbc106e14b77ba838.png";